/**
 * Создает полигон из строки
 * @param polygonString
 * @returns {Array}
 */
export function polygonFromString (polygonString) {
  let polygon = [];

  try {
    if (polygonString) {
      const points = JSON.parse(decodeURIComponent(polygonString));

      polygon = points.map(point => {
        return decodeURIComponent(point).split(',').map(Number);
      });
    }
  } catch (e) {}

  return polygon;
}

/**
 * Кодирует полигон в строку
 * @param polygon
 * @returns {any}
 */
export function polygonToString (polygon) {
  let polygonString = null;

  try {
    polygonString = (polygon && polygon.length > 4) ? JSON.stringify(polygon.slice(0, -1)) : null;
  } catch (e) {}

  return polygonString;
}

export function boundsFromString (boundsString) {
  if (!boundsString) {
    return null;
  }

  const split = boundsString.split(',');

  if (split.length !== 4) {
    return null;
  }

  const points = split.map(parseFloat).filter(Boolean);
  if (points.length !== 4) {
    return null;
  }

  return [[points[1], points[0]], [points[3], points[2]]];
}



// WEBPACK FOOTER //
// ./src/utils/polygon.js